import { useQueryClient } from '@tanstack/react-query'

// We can not use getGetProfileQueryKey() in this directory
const profileQueryKey = ['/profile']

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useCreateMutationOptions = (args: any) => {
  const queryClient = useQueryClient()

  return {
    ...args,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSuccess: (data: any) => {
      // Not all responses give a full profile after a mutation, but we want to reduce the profile calls
      if (data?.userId && data.userType && data.email) {
        queryClient.setQueryData(profileQueryKey, data)
      } else {
        // Invalidate the /profile query to prevent caching issues with the profile, after a mutation has successfully completed
        queryClient.invalidateQueries({ queryKey: profileQueryKey })
      }
    },
  }
}
